import type { IObservableValue, ObservableSet } from 'mobx'
import { createContext } from 'react'
import type { ImportExportTask } from '@companion-app/shared/Model/ImportExport.js'
import type { NotificationsManagerRef } from '~/Components/Notifications.js'
import type { HelpModalRef } from '~/Instances/HelpModal.js'
import type { WhatsNewModalRef } from '~/WhatsNewModal/WhatsNew.js'
import type { CompositeElementDefinitionsStore } from './CompositeElementDefinitionsStore.js'
import type { ConnectionsStore } from './ConnectionsStore.js'
import type { EntityDefinitionsStore } from './EntityDefinitionsStore.js'
import type { EventDefinitionsStore } from './EventDefinitionsStore.js'
import type { ExpressionVariablesListStore } from './ExpressionVariablesListStore.js'
import type { ImageLibraryStore } from './ImageLibraryStore.js'
import type { InstanceStatusesStore } from './InstanceStatusesStore.js'
import type { ModuleInfoStore } from './ModuleInfoStore.js'
import type { PagesStore } from './PagesStore.js'
import type { SurfaceInstancesStore } from './SurfaceInstancesStore.js'
import type { SurfacesStore } from './SurfacesStore.js'
import type { TriggersListStore } from './TriggersListStore.js'
import type { UserConfigStore } from './UserConfigStore.js'
import type { VariablesStore } from './VariablesStore.js'

export const RootAppStoreContext = createContext<RootAppStore>(null as any) // TODO - fix this?

export interface RootAppStore {
	readonly notifier: NotificationsManagerRef
	readonly helpViewer: React.RefObject<HelpModalRef | null> // TODO - this is not good
	readonly whatsNewModal: React.RefObject<WhatsNewModalRef | null> // TODO - this is not good

	readonly modules: ModuleInfoStore

	readonly connections: ConnectionsStore
	readonly surfaceInstances: SurfaceInstancesStore
	readonly instanceStatuses: InstanceStatusesStore

	/** Currently running 'learn' callbacks */
	readonly activeLearns: ObservableSet<string>

	readonly entityDefinitions: EntityDefinitionsStore
	readonly eventDefinitions: EventDefinitionsStore
	readonly compositeElementDefinitions: CompositeElementDefinitionsStore

	readonly pages: PagesStore
	readonly surfaces: SurfacesStore
	readonly variablesStore: VariablesStore
	readonly expressionVariablesList: ExpressionVariablesListStore

	readonly triggersList: TriggersListStore

	readonly userConfig: UserConfigStore

	readonly imageLibrary: ImageLibraryStore

	/** The current or most-recent import/reset task, driven by a single subscription (see useImportTaskStatusSubscription) */
	readonly importTaskStatus: IObservableValue<ImportExportTask | null>

	/**
	 * The setup wizard modal's open state. Set to `true` to open it; the modal sets it back to `false` on close.
	 * Doubles as the signal the What's New modal watches so it can wait its turn.
	 */
	readonly wizardOpen: IObservableValue<boolean>
}
